<p-slider
  *ngIf="visible"
  [(ngModel)]="value"
  [tabindex]="tabindex"
  [animate]="animate"
  [disabled]="disabled"
  [min]="min"
  [max]="max"
  [orientation]="orientation"
  [step]="step"
  [range]="range"
  [style]="style"
  [styleClass]="styleClass"
  (onChange)="mxChange($event)"
  (onSlideEnd)="mxSlideEnd($event)"
></p-slider>
<div class="flex align-items-center justify-content-between px-2 font-semibold">
  <span>{{ this.value[0] }}</span>
  <span>{{ this.value[1] }}</span>
</div>
